module.exports = __webpack_public_path__ + "img/coloured-patterns.2e95c171.svg";